import React from 'react';
import { useTranslation } from 'react-i18next';
import Block from '../../../Block';
import { Loader } from '../../../components';
import { useGetAppAdminDataByDayQuery } from '../../../../api/appAdminApiSlice';
import DailyDataTable from '../../../tables/DailyDataTable';

const DailyData = ({appId}) => {
  const {data: data_by_day=[], isSuccess, isError, refetch} = useGetAppAdminDataByDayQuery(appId)
  const loaderProps = { success: isSuccess, error: isError, retry: refetch }
  const { t } = useTranslation();

  return (
    <Block title={t('publisher.daily_data')}>
      <Loader {...loaderProps} minHeight={"100%"}>
        <DailyDataTable data_by_day={data_by_day}/>
      </Loader>
    </Block>
  )
}

export default DailyData
